import { mobileSyncActions } from '@redux/slices/mobile-sync-count';
import { getAppDispatch } from '@utilities/dispatch.util';

const mobileSyncCountApiJsonManipulation = ({ data }) => {
  const syncCountResponse = data;
  const syncedTasksCount =
    data?.syncedInspectionCount +
    data?.syncedWorkOrdersCount +
    data?.syncedHSECount +
    data?.syncedAssetCheckCount;

  const isSyncCountPlural = checkPlural({ assetCount: syncedTasksCount });
  const refreshModalObject = {
    assets: [
      {
        count: data?.siteCount || 0,
        text: `site${checkPlural({ assetCount: data?.siteCount })}`
      },
      {
        count: data?.equipmentCount || 0,
        text: `equipment`
      },
      {
        count: data?.structureCount || 0,
        text: `structure${checkPlural({ assetCount: data?.structureCount })}`
      },
      {
        count: data?.pipelineCount || 0,
        text: `pipeline`
      }
    ],

    assignedTasks: [
      {
        count: data?.workOrderCount || 0,
        text: `work order${checkPlural({ assetCount: data?.workOrderCount })}`
      },
      {
        count: data?.inspectionCount || 0,
        text: `inspection${checkPlural({ assetCount: data?.inspectionCount })}`
      },
      {
        count: data?.assetCheckCount || 0,
        text: `check${checkPlural({ assetCount: data?.assetCheckCount })}`
      }
    ],
    syncedTasks: [
      {
        count:
          data?.syncedInspectionCount +
          data?.syncedWorkOrdersCount +
          data?.syncedHSECount +
          data?.syncedAssetCheckCount,
        text: `synced task${isSyncCountPlural}/record${isSyncCountPlural}`
      }
    ],
    mobileForms: [
      {
        count: data?.inspectionFormCount,
        text: `mobile form${checkPlural({ assetCount: data?.inspectionFormCount })}`
      }
    ]
  };

  return {
    refreshModalObject,
    count: syncCountResponse
  };
};

const mobileSyncCountDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(mobileSyncActions.setMobileSyncCount(data));
};
export { mobileSyncCountApiJsonManipulation, mobileSyncCountDispatcher };

const checkPlural = ({ assetCount }) => {
  return assetCount === 1 || assetCount === 0 ? '' : 's';
};
